import { FichaService } from './../../ficha-veiculo/ficha-veiculo.service';
import { RecoverDataProposalProfessionalData } from './../../ficha-veiculo/ficha-cadastro/model/recover-data-proposal/recover-data-proposal-professional-data';
import { finalize, take } from 'rxjs/operators';
import {
  Component,
  DoCheck,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
  OnChanges,
} from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgForm,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { ClasseProfissionalService } from '../../services/classe-profissional/classe-profissional.service';
import { ProfissaoService } from './../../services/profissao/profissao.service';
import { ClasseProfissional } from './model/classe-profissional';
import { DadosProfissionais } from './model/dados-profissionais';
import { Empresa } from './model/empresa';
import { Profissao } from './model/profissao';
import { TempoExperiencia } from './model/tempo-experiencia';
import { AtributoTemporalService } from './../../services/atributo-temporal/atributo-temporal.service';
import { onlyDigits } from '../helper/utils';

@Component({
  selector: 'app-dados-profissionais',
  templateUrl: './dados-profissionais.component.html',
  styleUrls: ['./dados-profissionais.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DadosProfissionaisComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DadosProfissionaisComponent),
      multi: true,
    },
  ],
})
export class DadosProfissionaisComponent
  implements OnInit, DoCheck, Validator, ControlValueAccessor, OnChanges
{
  @Input() isPesados: boolean;
  @Input() dadoProfissionalInput: DadosProfissionais;
  @Input() professionalDataRecoverData: RecoverDataProposalProfessionalData;

  @ViewChild('possuiFamiliaresRamo', { static: true })
  possuiFamiliaresRamo: any;
  @ViewChild('naoPossuiFamiliaresRamo', { static: true })
  naoPossuiFamiliaresRamo: any;
  @ViewChild('form', { static: true }) form: NgForm;
  @Input() exibirCampoTelefone = true;

  dadosProfissionais: DadosProfissionais = new DadosProfissionais();
  classes: ClasseProfissional[] = [];
  profissoes: Profissao[] = [];
  listaTempoExperiencia: TempoExperiencia[] = [];

  isLoadingProfissao = false;
  isLoadingTempoExperiencia = false;

  public searchClass = true;
  public setted: boolean = false;
  public errorMessage: string = null;

  constructor(
    private readonly classeService: ClasseProfissionalService,
    private readonly profissaoService: ProfissaoService,
    private readonly atributoTemporalService: AtributoTemporalService,
    private readonly fichaService: FichaService
  ) {}

  ngOnInit() {
    this.buscarTempoExperiencia();
    this.loadClass();
    this.form.statusChanges.subscribe((status) => {
      this.validate();
    });
  }

  private loadClass(dadosRecuperados?: DadosProfissionais) {
    this.classeService
      .classes()
      .pipe(take(1))
      .subscribe((classes) => {
        this.handleClasses(classes);
        if (dadosRecuperados) {
          this.setDadosRecuperados(dadosRecuperados);
        }
      });
  }

  ngDoCheck() {
    if (this.dadosProfissionais.isSelectDados) {
      this.setClasseProfissionalIfSelected();
      this.buscarProfissoes();
    }

    if (this.form && this.form.controls['foneEmpresaCliente'] && !this.setted) {
      this.setted = true;
      this.form.controls['foneEmpresaCliente'].setAsyncValidators([
        this.validCelphone(),
      ]);
      this.form.controls['foneEmpresaCliente'].updateValueAndValidity();
    }

    this.setDadosPesadosIfSelected();
  }

  ngOnChanges() {
    if (
      this.dadoProfissionalInput &&
      this.dadoProfissionalInput.classeProfissional
    ) {
      this.dadosProfissionais.classeProfissional =
        this.classes.find(
          (cl) => cl.id === this.dadoProfissionalInput.classeProfissional.id
        ) || undefined;
    }
  }

  setDadosPesadosIfSelected() {
    if (this.isPesados) {
      this.setPossuiFamiliaresRamoIfSelected();
      this.setTempoExperienciaIfSelected();
    }
  }

  validate(): { [key: string]: any } {
    if (
      this.form &&
      this.form.controls['foneEmpresaCliente'] &&
      this.form.controls['foneEmpresaCliente'].invalid
    ) {
      return { valid: false };
    }
    if (this.isPesados) {
      return this.dadosProfissionais.valid &&
        this.dadosProfissionais.validPesados
        ? null
        : { valid: false };
    }
    return this.dadosProfissionais.valid ? null : { valid: false };
  }

  onChangeClasse() {
    this.resetValiablesChangeClasse();
    this.onChange();
    this.buscarProfissoes();
  }

  onChange() {
    this.propagateChange(this.dadosProfissionais);
  }

  public writeValue(obj: DadosProfissionais) {
    if (obj instanceof DadosProfissionais) {
      this.dadosProfissionais = obj;
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() {
    // This is intentional
  }

  private propagateChange = (_: any) => {
    // This is intentional
  }

  private resetValiablesChangeClasse() {
    this.profissoes = [];
    this.dadosProfissionais.profissao = undefined;
    this.dadosProfissionais.empresa = this.dadosProfissionais.isEmpresa
      ? this.dadosProfissionais.empresa
      : new Empresa();
  }

  private buscarProfissoes() {
    const idClasse = this.dadosProfissionais.idClasseProfissional;
    if (idClasse) {
      this.isLoadingProfissao = true;
      this.profissaoService
        .profissoes(idClasse)
        .pipe(
          take(1),
          finalize(() => (this.isLoadingProfissao = false))
        )
        .subscribe((result) => this.handleProfissoes(result.profissoes));
    }
  }

  private async buscarTempoExperiencia() {
    try {
      this.isLoadingTempoExperiencia = true;
      const response = await this.atributoTemporalService.listar(
        'TEMPO_EXPERIENCIA_RAMO'
      );
      this.listaTempoExperiencia = response || [];
    } finally {
      this.isLoadingTempoExperiencia = false;
    }
  }

  private handleClasses(classes: ClasseProfissional[]) {
    this.classes = classes;
    this.setClasseProfissionalIfSelected();
    this.buscarProfissoes();
  }

  private handleProfissoes(profissoes: Profissao[]) {
    this.profissoes = profissoes;
    this.setProfissaoIfSelected();
  }

  private setClasseProfissionalIfSelected() {
    if (this.dadosProfissionais.idClasseProfissional) {
      this.dadosProfissionais.dadosSelected();
      this.dadosProfissionais.classeProfissional =
        this.classes.find(
          (cl) => cl.id === this.dadosProfissionais.idClasseProfissional
        ) || undefined;
    }
  }

  private setProfissaoIfSelected() {
    if (this.dadosProfissionais.idProfissao) {
      this.dadosProfissionais.profissao =
        this.profissoes.find(
          (pr) => pr.id === this.dadosProfissionais.idProfissao
        ) || undefined;
    }
  }

  private setTempoExperienciaIfSelected() {
    if (this.dadosProfissionais.tempoExperienciaRamo) {
      this.dadosProfissionais.tempoExperiencia =
        this.listaTempoExperiencia.find(
          (te) =>
            te.valorNumerico === this.dadosProfissionais.tempoExperienciaRamo
        ) || undefined;
    }
  }

  private setPossuiFamiliaresRamoIfSelected() {
    if (this.dadosProfissionais.familiaresRamo === 'S') {
      this.possuiFamiliaresRamo.value = true;
      this.naoPossuiFamiliaresRamo.value = false;
    } else {
      this.dadosProfissionais.familiaresRamo = 'N';
      this.possuiFamiliaresRamo.value = false;
      this.naoPossuiFamiliaresRamo.value = true;
    }
  }

  setDadosRecuperados(dadosRecuperados: DadosProfissionais) {
    this.dadosProfissionais = dadosRecuperados;

    if (
      (this.dadosProfissionais.classeProfissional &&
        this.dadosProfissionais.classeProfissional.id) ||
      (this.professionalDataRecoverData &&
        this.professionalDataRecoverData.professionalClassId)
    ) {
      this.dadosProfissionais.dadosSelected();
      if (this.classes.length === 0 && this.searchClass) {
        this.loadClass(dadosRecuperados);
        this.searchClass = false;
      } else {
        this.dadosProfissionais.classeProfissional =
          this.classes.find(
            (cl) =>
              cl.id ===
                (this.dadosProfissionais.classeProfissional
                  ? this.dadosProfissionais.classeProfissional.id
                  : undefined) ||
              (this.professionalDataRecoverData
                ? this.professionalDataRecoverData.professionalClassId
                : undefined)
          ) || undefined;
      }
    }

    this.buscarProfissoes();
  }

  setPossuiFamiliaresRamo(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'possuiFamiliaresRamo') {
      this.naoPossuiFamiliaresRamo.value = !component.checked;
      this.dadosProfissionais.familiaresRamo = component.checked ? 'S' : 'N';
    } else {
      this.possuiFamiliaresRamo.value = !component.checked;
      this.dadosProfissionais.familiaresRamo = component.checked ? 'N' : 'S';
    }

    this.onChange();
  }

  hasNoValue(field) {
    return (
      field === null || field === undefined || field === ''
    );
  }

  compareByID(itemOne, itemTwo) {
    return itemOne && itemTwo && itemOne.id === itemTwo.id;
  }

  getDddAndCelular(value): { ddd: string; telefone: string } {
    if (!value || value === '') return { ddd: '', telefone: '' };
    const digits = onlyDigits(value);
    const ddd = digits.substring(0, 2);
    const telefone = digits.substring(2);
    return { ddd, telefone };
  }

  validCelphone(): AsyncValidatorFn {
    this.errorMessage = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      if (!control.value || control.value.length === 0) {
        return Promise.resolve(null);
      }
      const dddCelular = this.getDddAndCelular(control.value);
      return this.fichaService
        .verifyCellPhone(dddCelular.ddd, dddCelular.telefone)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessage = null;
            return null;
          }
          this.errorMessage = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  clearErrorMessage(errorMessageName: string) {
    this[errorMessageName] = null;
  }
}
